/** @file English catalog part of area E5 (W3-03); replaced whole by that area. */

/** The `editMesh` and `paintWeights` tool blocks (spread into `tools`). S0 composes it into `en`. */
export const meshToolsEn = {
  editMesh: {
    title: 'Edit mesh',
    clickMode: 'Click mode',
    modify: 'Modify',
    create: 'Create',
    remove: 'Delete',
    showIds: 'Vertex ids',
    keepImage: 'Keep image in place',
    deleteVertices: 'Delete vertices',
    retriangulate: 'Retriangulate',
    outlineHull: 'Outline as hull',
    flipEdge: 'Flip edge',
    addTriangle: 'Add triangle',
    removeTriangle: 'Remove triangle',
    noMesh: 'Select a slot that shows a mesh.',
    setupOnly: 'Vertices and triangles change in Setup mode; Animate mode keys deforms.',
    pickAnimation: 'Pick an animation to key the deform.',
    autoKeyOff: 'Auto-key is off and this frame has no deform key.',
    selectVertices: 'Select vertices first.',
    selectTwo: 'Select the two vertices of an inner edge.',
    selectThree: 'Select three vertices.',
    hullTooSmall: 'The outline keeps at least 3 vertices.',
    topologyFailed: 'The outline crosses itself or has no area: fix it first.',
    noOutline: 'The triangles do not form one outline.',
    noEdge: 'Those two vertices share no flippable edge.',
    triangleExists: 'That triangle already exists.',
    noTriangle: 'Those vertices are not a triangle of the mesh, or it is the last one.',
  },
  paintWeights: {
    title: 'Paint weights',
    rigid: 'This mesh is rigid: make it skinned in the Weights panel first.',
    mode: 'Brush',
    add: 'Add',
    subtract: 'Subtract',
    replace: 'Replace',
    smooth: 'Smooth',
    bone: 'Paint bone',
    radius: 'Radius (px)',
    strength: 'Strength',
    hardness: 'Hardness',
    value: 'Value',
    autoNormalize: 'Auto-normalise',
    staleBind: "This mesh's bind is older than its bones' setup pose: Rebind at setup (Weights panel) keeps the setup look before you paint.",
  },
} as const;
